"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../../foundations/icons/Icon.js");
const textInput = "_textInput_4oaur_1";
const iconWrapper = "_iconWrapper_4oaur_38";
const styles = {
  textInput,
  "textInput-success": "_textInput-success_4oaur_23",
  "textInput-error": "_textInput-error_4oaur_24",
  iconWrapper,
  "icon-error": "_icon-error_4oaur_49",
  "icon-success": "_icon-success_4oaur_53"
};
const TextInput = React.forwardRef(
  ({ required, isError, isSuccess, className, addon, ...props }, ref) => {
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
      /* @__PURE__ */ jsxRuntime.jsx(
        "input",
        {
          ...props,
          ref,
          required,
          className: clsx.clsx(
            styles.textInput,
            styles.textInput,
            isError && styles["textInput-error"],
            isSuccess && styles["textInput-success"],
            className
          )
        }
      ),
      /* @__PURE__ */ jsxRuntime.jsxs("div", { className: styles.iconWrapper, children: [
        addon,
        isError && /* @__PURE__ */ jsxRuntime.jsx(foundations_icons_Icon.Icon, { width: 24, height: 24, className: clsx.clsx(styles["icon-error"]), variant: "Error" }),
        isSuccess && /* @__PURE__ */ jsxRuntime.jsx(
          foundations_icons_Icon.Icon,
          {
            width: 24,
            height: 24,
            className: clsx.clsx(styles["icon-success"]),
            variant: "Check1"
          }
        )
      ] })
    ] });
  }
);
exports.TextInput = TextInput;
